<script>
import Mixin from "@/pages/inspection_reports/form-sections/mixin";

export default {
	mixins: [Mixin]
}
</script>

<template>
	<div class="col-xl-6">
		<Card class="h-100">
			<h2 v-if="group.title" class="card-title mb-3">{{ group.title }}</h2>

			<template v-if="group.values" v-for="(config, name, index) in group.values" :key="name">
				<component
					:is="config.type"
					:model-value="config.value"
					@update:modelValue="this.$emit('update:form', {group: group.name, input: name, value: $event, type: 'value'})"
					@update:option="this.$emit('update:form', {group: group.name, input: name, option: $event, type: 'option'})"
					:name="name"
					:label="config.label"
					:groupClasses="'my-0 py-3 ' + ((Object.keys(group.values).length - 1) === index ? '' : 'border-bottom')"
					:extra="config.extra"
					:testValue="config.testValue"
					:cylinders="config.cylinders"
					:callback="config.callback"
					:options="config.options"
					:option="config.option"
				/>
			</template>

		</Card>
	</div>
</template>